<template>
  <div class="feature-row d-flex flex-wrap justify-center">
    <div
      v-for="feature of flatFeatures"
      :key="feature"
      class="feature-pill d-flex align-center ma-1 px-3 py-2"
    >
      <v-icon
        small
        color="success"
        class="mr-2"
      >
        check_circle
      </v-icon>
      <span class="caption font-weight-medium">
        {{ $t('subscriptions.features.' + feature) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: "FeatureList",
        data: () => ({
            features: [
                ['aiWriting', 'seoScore'],
                ['instructions', 'export'],
                ['chatGpt', 'keywordAnalysis', 'inspiration']
            ]
        }),
        computed: {
            flatFeatures(): string[] {
                return this.features.reduce((acc: string[], group) => acc.concat(group), []);
            }
        }
    });
</script>

<style lang="sass" scoped>
.feature-pill
    background: var(--v-blockSurface-base, rgba(8, 135, 220, 0.06))
    border-radius: 999px

.theme--dark .feature-pill
    background: rgba(255, 255, 255, 0.06)
</style>
